
import { FileAction } from '../../@types/redux';
import { getType } from 'typesafe-actions';
import { IFileQueue } from '../../@types/model/fileUpload/fileUpload';
import fileActions from './actions';

export interface IFileState {
    files : Array<IFileQueue>;
    uploadProgress : number;
    current ?: string;
}

const initialState = {
    files: [],
    uploadProgress: 0,
};

export default function fileReducer(state : IFileState = initialState, action : FileAction) : IFileState {
    switch (action.type) {
        case getType(fileActions.setFiles):
            return { ...state, files: action.payload };
        case getType(fileActions.setProgress):
            return { ...state, uploadProgress: action.payload };
        case getType(fileActions.setCurrent):
            return { ...state, current: action.payload };
        default:
            return state;
    }
}
